import { BuildingStatus } from '../land/state'

// Castle1 only has specific buildings, so use Partial<BuildingStatus>
export interface Castle1State {
  buildingStatus: Partial<BuildingStatus>
  isLoading: boolean
  isImmediate: boolean
  error?: string
  isRestored: boolean
  repairRequirements: {
    ecsToken: number
    gem: number
    iron?: number
    stone: number
    wood: number
    repairTime?: number
    repairCooldown?: Date | null
  }
  supportCharacters: any[]
  isSetSupportCharacterSuccess: boolean
  supportState: boolean
  upgradeRequirements: {
    ecsToken: number
  }
  upgradeAvailable: boolean
  allMiningStatus: {
    [key: string]: any
  }
}

export const initialCastle1State: Castle1State = {
  buildingStatus: {
    support: {
      level: 0,
      hp: 0,
      maxHp: 0,
      characters: []
    },
    wheatFarm: {
      level: 0,
      hp: 0,
      maxHp: 0,
      characters: null
    },
    bakery: {
      level: 0,
      hp: 0,
      maxHp: 0,
      characters: null
    },
    hospital: {
      level: 0,
      hp: 0,
      maxHp: 0,
      characters: null
    }
  },
  isLoading: false,
  isImmediate: false,
  error: undefined,
  isRestored: false,
  repairRequirements: {
    ecsToken: 0,
    gem: 0,
    iron: 0,
    stone: 0,
    wood: 0,
    repairTime: 0,
    repairCooldown: null,
  },
  supportCharacters: [],
  isSetSupportCharacterSuccess: false,
  supportState: false,
  upgradeRequirements: {
    ecsToken: 0,
  },
  upgradeAvailable: false,
  allMiningStatus: {},
}

